import { useTranslation } from 'react-i18next';

import { Listbox } from '@/components/ui/listbox';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/utils/cn';

export const DashboardLayoutSwitcher = ({
  layouts,
  activeLayoutId,
  disabled,
  loading = false,
  onActivate,
  className,
}: {
  layouts: Array<{ id: string; name: string }>;
  activeLayoutId: string | undefined;
  disabled?: boolean;
  loading?: boolean;
  onActivate: (layoutId: string) => void;
  className?: string;
}) => {
  const { t } = useTranslation('reports');

  if (layouts.length <= 1) return null;

  return (
    <div
      className={cn('flex items-center gap-1.5', className)}
      aria-busy={loading || undefined}
      aria-live="polite"
    >
      {loading ? (
        <Spinner className="size-3.5 shrink-0 text-fg-tertiary" />
      ) : null}
      <Listbox
        value={activeLayoutId ?? null}
        onChange={(value) => {
          if (value) onActivate(value);
        }}
        options={layouts.map((layout) => ({
          value: layout.id,
          label: layout.name,
        }))}
        size="sm"
        compact
        disabled={disabled || loading}
        aria-label={
          loading ? t('home.layouts.switching') : t('home.layouts.switchAriaLabel')
        }
        className={cn(
          'h-7 max-w-[11rem] border-transparent bg-transparent px-1.5 py-0 text-caption shadow-none',
          'hover:border-transparent hover:bg-surface-sunken/60',
          'focus-visible:ring-1 focus-visible:ring-brand',
        )}
      />
    </div>
  );
};
